export default __webpack_public_path__ + "static/media/1079.db154fc2.png";